import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";




export const authLogin = createAsyncThunk("auth/authLogin", async (item, thunkAPI) => {
  try {
    const data = await AuthService.login(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const logout = createAsyncThunk("auth/logout", async () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");

  return true;
});
export const forgotPasswords = createAsyncThunk("auth/forgotPasswords", async (item, thunkAPI) => {
  try {
    const data = await AuthService.forgotPassword(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const verifyOtpAndSetPassword = createAsyncThunk("auth/verifyOtpAndSetPassword", async (item, thunkAPI) => {
  try {
    const data = await AuthService.setPassword(item);
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
  }
});



export const getRoles = createAsyncThunk("auth/getRoles", async (thunkApi) => {
  try {
    const response = await AuthService.getRoles();
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});


export const getProfile = createAsyncThunk("auth/getProfile", async (thunkApi) => {
  try {
    const response = await AuthService.FetchProfile();
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});

export const getuserProfile = createAsyncThunk("auth/getuserProfile", async (thunkApi) => {
  try {
    const response = await AuthService.getProfile();
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});



export const changePassword = createAsyncThunk("auth/changePassword", async (item, thunkApi) => {
  try {
    const response = await AuthService.changePassword(item);
    return response.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error.response?.data?.message || error.message);
  }
});



const initialState = {
  loading: false,
  error: "",
  authdata: [],
  user: AuthService.getUserDetails() || null,
};


const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // **Handle Login**
      .addCase(authLogin.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.user = null;
      })
      .addCase(authLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(authLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(logout.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.error = "";
        state.user = null;
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(getRoles.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(getRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


export default authSlice.reducer;
